import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activeSalesforceImport: state.salesforce.activeSalesforceImport,
});

angular
  .module('myConsultApp')
  .controller(
    'salesforceImportCreateEditController',
    ($ngRedux, $rootScope, $scope, $timeout, $http, ENV) => {
      $scope.initData = () => {
        $scope.currentSalesforceImport = {
          filename_schema: '',
        };
        $scope.salesforceImportProcessing = false;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };
        $scope.title = 'Create Filename Schema To Import';
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.applyError = (error) => {
        const errorData = error.data['salesforce-file'];
        const details = [];

        Object.keys(errorData).map((key) => {
          if (typeof errorData[key] === 'string') {
            $scope.error.highlightedFields[key] = [errorData[key]];
          } else if (Array.isArray(errorData[key])) {
            $scope.error.highlightedFields[key] = errorData[key];
          } else {
            $scope.error.highlightedFields[key] = Object.values(errorData[key]);
          }
        });

        if (error.status === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (error.status === 400) {
          if (Object.keys($scope.error.highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else if (error.status === 403) {
          details.push('You do not have permission to perform this action.');
        } else {
          details.push(error.statusText);
        }
        $scope.error.details = details;
      };

      $scope.applySuccess = (keepPage = false) => {
        $scope.close();
        $rootScope.getData(keepPage);
      };

      $scope.deleteEntry = () => {
        if ($scope.currentSalesforceImport.id) {
          $scope.salesforceImportProcessing = true;
          $scope
            .deleteSalesforceImport($http, ENV, $scope.currentSalesforceImport.id)
            .then(() => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applySuccess(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.submitSalesforceImport = () => {
        const payload = {
          'salesforce-file': $scope.currentSalesforceImport,
        };
        const currentSalesforceImportId = $scope.currentSalesforceImport.id;
        $scope.salesforceImportProcessing = true;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };

        if (!currentSalesforceImportId) {
          $scope
            .createSalesforceImport($http, ENV, payload)
            .then(() => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applySuccess();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applyError(error);
              });
            });
        } else {
          $scope
            .updateSalesforceImport($http, ENV, currentSalesforceImportId, payload)
            .then(() => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applySuccess(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.salesforceImportProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.close = () => {
        $scope.setSalesforceImport(null);
        $rootScope.closeComponent();
      };

      $scope.clearForm = () => {
        if ($scope.salesforceImportForm) {
          $scope.salesforceImportForm.$setUntouched();
          $scope.salesforceImportForm.$setPristine();
        }
      };

      $scope.$watch('activeSalesforceImport', () => {
        if ($scope.activeSalesforceImport) {
          $scope.title = 'Edit Filename Schema To Import';
          $scope.currentSalesforceImport = angular.copy($scope.activeSalesforceImport);
        } else {
          $scope.initData();
        }
      });

      $scope.$watch('subComponent', (newValue, oldValue) => {
        if (oldValue === 'create-salesforce-import' || oldValue === 'edit-salesforce-import') {
          $scope.initData();
          $scope.clearForm();
        }
      });

      $scope.init();
      $scope.initData();
      $scope.$on('$destroy', $scope.unsubscribe);
    },
  )
  .directive('salesforceImportCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/salesforce-import-create-edit.html',
    };
  });
